export default window.__env
